export function getEntityPaneKey(key: string, entityId: number) {
    return `${key}-${entityId}` as const;
}

export type EntityPaneKey = ReturnType<typeof getEntityPaneKey>;
